import { t } from 'translates';

export default {
  months: [
    t('January', DT_DATEPICKER),
    t('February', DT_DATEPICKER),
    t('March', DT_DATEPICKER),
    t('April', DT_DATEPICKER),
    t('May', DT_DATEPICKER),
    t('June', DT_DATEPICKER),
    t('July', DT_DATEPICKER),
    t('August', DT_DATEPICKER),
    t('September', DT_DATEPICKER),
    t('October', DT_DATEPICKER),
    t('November', DT_DATEPICKER),
    t('December', DT_DATEPICKER),
  ],
  weekdaysLong: [
    t('Sunday', DT_DATEPICKER),
    t('Monday', DT_DATEPICKER),
    t('Tuesday', DT_DATEPICKER),
    t('Wednesday', DT_DATEPICKER),
    t('Thursday', DT_DATEPICKER),
    t('Friday', DT_DATEPICKER),
    t('Saturday', DT_DATEPICKER),
  ],
  weekdaysShort: [
    t('Su', DT_DATEPICKER),
    t('Mo', DT_DATEPICKER),
    t('Tu', DT_DATEPICKER),
    t('We', DT_DATEPICKER),
    t('Th', DT_DATEPICKER),
    t('Fr', DT_DATEPICKER),
    t('Sa', DT_DATEPICKER),
  ],
}
